import React, { useEffect } from 'react';
import VacanciesCard from '../relevanter/components/VacanciesCard';
import { useVacancyStore } from '../store/vacancyStore';

function HHResponsesPage() {
  const { setSelectedVacancyById } = useVacancyStore();

  useEffect(() => {
    setSelectedVacancyById(null);
  }, [setSelectedVacancyById]);

  return (
    <div className="bg-[#f5f6f1] relative h-full overflow-visible">
      <div className="relative h-full overflow-visible">
        <div className="relative h-full overflow-visible">
          <div className="w-full h-full">
            <div className="flex flex-col gap-6 w-full h-full">
              <div className="bg-[#f5f6f1] box-border content-stretch flex flex-col gap-[10px] items-start justify-start relative shrink-0 w-full flex-1 h-full overflow-visible">
                <div className="w-full h-full mt-[1px] overflow-y-auto p-[16px] flex flex-col">
                  <VacanciesCard onBackToSearch={() => {}} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HHResponsesPage;

